// extracted by mini-css-extract-plugin
module.exports = {"userImage":"style-module--userImage--1mmq6"};